export const apiListOrder = "/1.0/wsm/poolData/order/list"
export const apiDetailOrder = id => `/1.0/wsm/poolData/order/${id}/detail`
export const apiDeleteOrder = id => `/1.0/wsm/poolData/order/${id}/delete`
export const apiUpdateOrder = id => `/1.0/wsm/poolData/order/${id}/update`
export const apiCreateOrder = "/1.0/wsm/poolData/order/create"
export const apiListOrderM2M = "/1.0/wsm/poolData/package/order/list"
export const apiDetailOrderM2M = id => `/1.0/wsm/poolData/package/order/${id}/detail`
export const apiDeleteOrderM2M = id => `/1.0/wsm/poolData/package/order/${id}/delete`
export const apiUpdateOrderM2M = id => `/1.0/wsm/poolData/package/order/${id}/update`
export const apiCreateOrderM2M = "/1.0/wsm/poolData/package/order/create"
export const apiBrowseOrderM2M = id => `/1.0/wsm/poolData/package/order/${id}/browse`
export const apiRefuseOrderM2M = id => `/1.0/wsm/poolData/package/order/${id}/refuse`